<template>
    <b-card no-body :header="$t('prod_osts', { ns: 'production' })">
        <b-table
            :items="groupedDisplayList"
            :fields="visibleFields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :filter-included-fields="filterOn"
            stacked="md"
            show-empty
            :empty-text="$t('com_geen_data', { ns: 'common' })"
            small
            striped
            @filtered="onFiltered"
        >
            <template v-slot:cell(actions)="row">
                <b-button
                    size="sm"
                    @click="linkItem(row.item)"
                    class="bgc_aux_normal"
                    ><font-awesome-icon icon="link" size="1x" />
                </b-button>
                <b-button
                    size="sm"
                    @click="toonStappen(row.item)"
                    class="bgc_aux_unknown"
                    ><font-awesome-icon icon="info-circle" size="1x" />
                </b-button>
            </template>

            <template v-slot:row-details>
                <b-table
                    striped
                    responsive
                    :fields="detailFields"
                    :items="detailList"
                />
            </template>
        </b-table>
        <bak-selector
            v-if="showBakSelector"
            :visible="showBakSelector"
            :datum="prodTijd"
            @input="setBatch"
        />
    </b-card>
</template>

<script>
import { loadItem, loadList } from '@/models/DataHelper';
import DateHelper from '@/models/DateHelper';
import BakSelector from '../components/BakSelector.vue';

export default {
    name: 'CardFixOst',
    data() {
        return {
            totalRows: 1,
            currentPage: 1,
            perPage: 20,
            pageOptions: [10, 20, 40, { value: 100, text: '100' }],
            filter: null,
            list: null,
            filterOn: [],
            detaillist: [],
            selectedKey: null,
            prodTijd: null,
            showBakSelector: false
        };
    },
    components: {
        BakSelector
    },
    props: {
        theList: {
            default: null
        },
        editAllowed: {
            type: Boolean,
            default: false
        },
        prodDate: {
            default: null
        }    
    },
    computed: {
        readonly() {
            return !this.editAllowed;
        },
        visibleFields() {
            const fieldsInit = [
                { key: 'actions', label: ' ', visible: true },
                {
                    key: 'tijd',
                    label: this.$t('com_tijd', { ns: 'common' }),
                    sortable: true,
                    visible: true,
                    formatter: this.displayDate
                },
                {
                    key: 'programma',
                    label: this.$t('prod_xprogramma', {
                                        ns: 'production',
                                        val: this.$t('prod_ost', {
                                            ns: 'production'
                                        })
                                    }),
                    sortable: true,
                    visible: true
                },
                {
                    key: 'stappen.length',
                    label: this.$t('prod_steps', { ns: 'production' }),
                    sortable: true,
                    visible: true
                }
            ];
            return fieldsInit.filter((field) => field.visible);
        },
        detailFields() {
            const fieldsInit = [
                {
                    key: 'stapnummer',
                    label: this.$t('prod_step', { ns: 'production' }),
                    sortable: true,
                    visible: true
                },
                {
                    key: 'stap',
                    label: this.$t('rec_omschrijving', { ns: 'recurrency' }),
                    sortable: false,
                    visible: true
                },
                {
                    key: 'tijd',
                    label: this.$t('com_tijd', { ns: 'common' }),
                    sortable: true,
                    visible: true,
                    formatter: this.displayDateTime
                },
                {
                    key: 'volume',
                    label: this.$t('com_volume', { ns: 'common' }),
                    sortable: true,
                    visible: true
                },
                {
                    key: 'temperatuur',
                    label: this.$t('com_temperatuur', { ns: 'common' }),
                    sortable: false,
                    visible: true
                }
            ];
            return fieldsInit.filter((field) => field.visible);
        },
        groupedDisplayList() {
            if (this.list == undefined) return null;
            const x = _(this.list.slice(0))
                .groupBy((x) => x.key)
                .map((value, key) => {
                    const tijd = value[0].tijd;
                    const programma = value[0].programma;
                    return {
                        tijd: tijd,
                        key: key,
                        programma: programma,
                        stappen: value
                    };
                })
                .value();
            return x;
        }
    },
    methods: {
        displayDate(value) {
            return DateHelper.convertedToDate(value, false);
        },
        displayDateTime(value) {
            return DateHelper.convertedToDateTimeShort(value);
        },
        
        toonStappen(row) {
            if (row._showDetails) {
                this.$set(row, '_showDetails', false);
            } else {
                this.groupedDisplayList.forEach((row) => {
                    this.$set(row, '_showDetails', false);
                });

                const item = row.item ? row.item : row;
                this.detailList = item.stappen.sort((a,b) => a.stapnummer - b.stapnummer);
                this.$set(row, '_showDetails', true);
            }
        },
        reset() {
            this.showBakSelector = false;
        },
        async setBatch(bakID) {
            if(bakID == null || bakID <= 0) {
                this.showBakSelector = false;
                return;
            }
            const LinkOstDataModel = {
                BatchID: bakID,
                DataKey: this.selectedKey
            };
            const result = await loadItem(
                'extern/storeLinkOstData',
                LinkOstDataModel,
                this.$t
            );
            this.showBakSelector = false;
            this.loadData();
        },
        linkItem(item) {
            //this.prodTijd = DateHelper.convertedToDate(item.tijd, false);
            this.selectedKey = item.key ? item.key : item.item.key;
            this.showBakSelector = true;
        },
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        async loadData() {
            const report = '/Reporting/ImportOstDataErrorReport';
            const payload = {
                data: null,
                report: report
            };
            this.list = await loadList(
                'rapportage/getReportItems',
                'rapportage/loadReport',
                payload,
                true,
                this.$t
            );
        }
    },
    mounted() {},
    async created() {
        if (this.prodDate) {
            this.prodTijd = DateHelper.convertedToDate(this.prodDate, false);
        }
        if (this.theList == undefined) {
            await this.loadData();
            //this.list = Helper.replaceValueInObject(this.list, null, '');

        }else {
            this.list = this.theList;
        }
    }
};
</script>

